<div class="add_carrier_driver">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <ngx-loading [show]="isLoading"></ngx-loading>

  <div class="page_header">
    <!-- <h1>
      <ng-container *ngIf="!driverId"> ADD DRIVER </ng-container>
      <ng-container *ngIf="driverId"> UPDATE DRIVER </ng-container>
    </h1> -->
  </div>
  <div class="carrier_details">
    <h2>Carrier Details</h2>
    <div class="detail_row" *ngIf="carrierDetails.Carrier">
      <div class="column">Company registered name:</div>
      <div class="column">{{ carrierDetails.Carrier.registered_name }}</div>
    </div>
    <div class="detail_row" *ngIf="carrierDetails.Carrier">
      <div class="column">Company registered number:</div>
      <div class="column">{{ carrierDetails.Carrier.registration_number }}</div>
    </div>
    <div class="detail_row" *ngIf="carrierDetails.Carrier">
      <div class="column">Trading name:</div>
      <div class="column">{{ carrierDetails.Carrier.trading_name }}</div>
    </div>
    <div class="detail_row" *ngIf="carrierDetails.Carrier">
      <div class="column">Type of carrier:</div>
      <div class="column"> {{carrierDetails.Carrier.freight_passenger_ind |carrierType }}</div>
    </div>
    <div class="detail_row" *ngIf="carrierDetails.Contact">
      <div class="column">Email Address:</div>
      <div class="column">{{ carrierDetails.Contact.EmailAddress }}</div>
    </div>
    <div class="detail_row" *ngIf="carrierDetails">
      <div class="column">Telephone:</div>
      <div class="column">{{carrierDetails.dial_code_tele}} {{ carrierDetails.telephone }}</div>
    </div>
    <div class="detail_row" *ngIf="carrierDetails.Contact">
      <div class="column">Cellphone:</div>
      <!-- <div class="column">{{carrierDetails.Contact.dial_code_cell}} {{ carrierDetails.Contact.MobileNumber }}</div> -->
      <div class="column"> {{ carrierDetails.Contact.MobileNumber }}</div>
    </div>
  </div>
  <form class="form" [formGroup]="driverForm">
    <h2>Driver info</h2>
    <div class="row form_flex_row">
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="depot_id">Depot Name <a
          class="red-asterik">*</a></label>
        <!-- <input
          type="text"
          id="depot_id"
          formControlName="depot_id"
          class="form-control"
          placeholder="Depot ID"
        /> -->
        <select
          name="depot_id"
          id="depot_id"
          formControlName="depot_id"
          class="form-control"
        >
          <option selected hidden disabled>Select Depot Name</option>
          <ng-container *ngFor="let type of depots">
            <option [value]="type.id">{{ type.name }}</option>
          </ng-container>
        </select>
        <div *ngIf="driverForm.controls.depot_id.invalid && driverForm.controls.depot_id.touched">
          <p *ngIf="driverForm.controls.depot_id.errors.required" class="form-control-feedback text-danger text-small text-red pt-3">
            * Required
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="id_type">ID Type <a
          class="red-asterik">*</a></label>
        <select
          name="branch"
          id="id_type"
          formControlName="id_type_ind"
          class="form-control"
          (change)="onChange($event.target.value)"
        >
          <option selected hidden disabled>Select ID Type</option>
          <ng-container *ngFor="let type of idTypes">
            <option [value]="type.key">{{ type.value }}</option>
          </ng-container>
        </select>
        <div *ngIf="driverForm.controls.id_type_ind.invalid && driverForm.controls.id_type_ind.touched">
          <p *ngIf="driverForm.controls.id_type_ind.errors.required" class="form-control-feedback text-danger text-small text-red pt-3">
            * Required
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6 form_field" *ngIf="driverForm.controls.id_type_ind.value == 2">
        <label class="label" for="passport_country_id"
          >Passport Country ID <a
          class="red-asterik">*</a></label
        >
        <!-- <input
          type="text"
          id="passport_country_id"
          formControlName="passport_country_id"
          class="form-control"
          placeholder="Passport Country ID"
        /> -->
        <select
          name="passport_country_id"
          id="passport_country_id"
          formControlName="passport_country_id"
          class="form-control"
        >
          <option selected hidden disabled>Select Passport Country</option>
          <ng-container *ngFor="let type of ddlCountries">
            <option [value]="type.id">{{ type.desc }}</option>
          </ng-container>
        </select>
        <div *ngIf="driverForm.controls.passport_country_id.invalid && driverForm.controls.passport_country_id.touched">
          <p *ngIf="driverForm.controls.passport_country_id.errors.required" class="form-control-feedback text-danger text-small text-red pt-3">
            * Required
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6 form_field" *ngIf="driverForm.controls.id_type_ind.value == 2">
        <label class="label" for="passport_number">Passport Number <a
          class="red-asterik">*</a></label>
        <input
          type="text"
          id="passport_number"
          (keypress)="numbersOnly($event)"
          formControlName="passport_number"
          class="form-control"
          placeholder="Passport Number"
        />
        <div *ngIf="driverForm.controls.passport_number.invalid && driverForm.controls.passport_number.touched">
          <p *ngIf="driverForm.controls.passport_number.errors.required" class="form-control-feedback text-danger text-small text-red pt-3">
            * Required
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6 form_field" *ngIf="!(driverForm.controls.id_type_ind.value == 2)">
        <label class="label" for="passport_number">ID Number <a
          class="red-asterik">*</a></label>
        <input
        type="text"
          id="id_number"
          (keypress)="numbersOnly($event)"
        (blur)="getHomeAffairsCarrierDetails()"
          formControlName="id_number"
          class="form-control"
          placeholder="ID Number"
        maxlength="13"/>
        <div *ngIf="driverForm.controls.id_number.invalid && driverForm.controls.id_number.touched">
          <p *ngIf="driverForm.controls.id_number.errors.required" class="form-control-feedback text-danger text-small text-red pt-3">
            * Required
          </p>
          <p *ngIf="driverForm.controls.id_number.errors.invalid_id" class="form-control-feedback text-danger text-small text-red pt-3">
            * Invalid ID Number
          </p>
        </div>


      </div>
      <div class="col-12 col-md-6 form_field" [style]="driverForm.controls.id_type_ind.value == 2?'display: block;':'display:none'">
        <label class="label" for="dob"
          >Passport Expiry Date <a class="red-asterik">*</a></label
        >
        <div class="input-group">
          <input
          ngbDatepicker #passportExpiryDatePicker="ngbDatepicker" (click)="passportExpiryDatePicker.toggle()"
          type="text"
          value="{{ passport_expiry_date | date:'dd/MM/yyyy' }}"
          [placement]="'top'"
          container="body"
          readonly
          name="passport_expiry_date"
          formControlName="passport_expiry_date"
          class="form-control"
          placeholder="Passport Expiry Date"
          [minDate]="currentDate"
          [ngClass]="{'error': driverForm.controls.passport_expiry_date.invalid && driverForm.controls.passport_expiry_date.dirty, 'noerror': driverForm.controls.passport_expiry_date.valid && driverForm.controls.passport_expiry_date.dirty}" />
      
          <!-- <div class="input-group-append">
            <span class="input-group-text">
              <i class="fa fa-calendar" (click)="date_of_birth.toggle()"></i>
            </span>
          </div> -->
        </div>
        <div *ngIf="driverForm.controls.passport_expiry_date.invalid && driverForm.controls.passport_expiry_date.touched">
          <p *ngIf="driverForm.controls.passport_expiry_date.errors.required" class="form-control-feedback text-danger text-small text-red pt-3">
            * Required
          </p>
        </div>
      </div>
    
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="firstname">First Name <a
          class="red-asterik">*</a></label>
        <input
          type="text"
          id="firstname"
          formControlName="first_name"
          class="form-control"
          [readOnly]="homeaffairsReadOnly"
          placeholder="First Name"
          (keypress)="letterOnly($event)"
        />
        <div *ngIf="driverForm.controls.first_name.invalid && driverForm.controls.first_name.touched">
          <p *ngIf="driverForm.controls.first_name.errors.required" class="form-control-feedback text-danger text-small text-red pt-3">
            * Required
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="lastname">Last Name <a
          class="red-asterik">*</a></label>
        <input
          type="text"
          id="lastname"
          formControlName="last_name"
          class="form-control"
          placeholder="Last Name"
          [readOnly]="homeaffairsReadOnly"
          (keypress)="letterOnly($event)"
        />
        <div *ngIf="driverForm.controls.last_name.invalid && driverForm.controls.last_name.touched">
          <p *ngIf="driverForm.controls.last_name.errors.required" class="form-control-feedback text-danger text-small text-red pt-3">
            * Required
          </p>
        </div>
      </div>
      <!-- <div class="col-12 col-md-6 form_field">
        <label class="label" for="dob">Date of Birth <a
          class="red-asterik">*</a></label>
        <input
          type="date"
          id="dob"
          formControlName="date_of_birth"
          class="form-control"
          placeholder="Date of Birth"
          [value]="driverForm.controls.date_of_birth.value | date:'yyyy-MM-dd'"
        />
        <div *ngIf="driverForm.controls.date_of_birth.invalid && driverForm.controls.date_of_birth.touched">
          <p *ngIf="driverForm.controls.date_of_birth.errors.required" class="form-control-feedback text-danger text-small text-red pt-3">
            * Required
          </p>
        </div>
      </div> -->

      <div class="col-12 col-md-6 form_field">
        <label class="label" for="dob"
          >Date of Birth <a class="red-asterik">*</a></label
        >
        <div class="input-group">
          <input
          ngbDatepicker #dobDatePicker="ngbDatepicker" (click)="dobDatePicker.toggle()"
          type="text"
          value="{{ date_of_birth | date:'dd/MM/yyyy' }}"
          [placement]="'top'"
          container="body"
          readonly
          name="date_of_birth"
          formControlName="date_of_birth"
          class="form-control"
          placeholder="Date of Birth"
          [maxDate]="maxDOB"
          [disabled]="homeaffairsReadOnly"
          [ngClass]="{'error': driverForm.controls.date_of_birth.invalid && driverForm.controls.date_of_birth.dirty, 'noerror': driverForm.controls.date_of_birth.valid && driverForm.controls.date_of_birth.dirty}" />
      
          <!-- <div class="input-group-append">
            <span class="input-group-text">
              <i class="fa fa-calendar" (click)="date_of_birth.toggle()"></i>
            </span>
          </div> -->
        </div>
        <div *ngIf="driverForm.controls.date_of_birth.invalid && driverForm.controls.date_of_birth.touched">
          <p *ngIf="driverForm.controls.date_of_birth.errors.required" class="form-control-feedback text-danger text-small text-red pt-3">
            * Required
          </p>
        </div>
      </div>

      <div class="col-12 col-md-6 form_field">
        <label class="label" for="gender">Gender <a
          class="red-asterik">*</a></label>
        <select
          name="id_type"
          id="id_type"
          formControlName="gender"
          class="form-control"
        >
          <option selected hidden disabled>Select Gender <a
            class="red-asterik">*</a></option>
          <ng-container *ngFor="let type of genderTypes">
            <option [value]="type.key"    [disabled]="homeaffairsReadOnly">{{ type.value }}</option>
          </ng-container>
        </select>
        <div *ngIf="driverForm.controls.gender.invalid && driverForm.controls.gender.touched">
          <p *ngIf="driverForm.controls.gender.errors.required" class="form-control-feedback text-danger text-small text-red pt-3">
            * Required
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="cellphone">Cellphone<a class="red-asterik">*</a></label>
        <ngx-intl-tel-input [cssClass]="'form-control input-sm'"
          [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
          [searchCountryFlag]="true" 
          (keypress)="numbersOnly($event)"
          [searchCountryField]="[
            SearchCountryField.Iso2,
            SearchCountryField.Name
          ]" [selectFirstCountry]="false" [maxLength]="15" [tooltipField]="TooltipLabel.Name" [phoneValidation]="true"
          [selectedCountryISO]="defaultCountry" [separateDialCode]="separateDialCode"
          (countryChange)="ChangeCountry($event)" name="Cellphone" formControlName="cellphone" #MobileNumber
          (keyup)="validatePhone(driverForm.value.cellphone)">
        </ngx-intl-tel-input>
        <div class="form-control-feedback text-danger text-small"
          *ngIf="driverForm.controls.cellphone.invalid && driverForm.controls.cellphone.touched">
          <p>Invalid Cellphone Number</p>
        </div>
      </div>
      
      <!-- <div class="col-12 col-md-6 form_field">
        <label class="label" for="cellphone">Cellphone <a
          class="red-asterik">*</a></label>
        <ngx-intl-tel-input
          [cssClass]="'form-control input-sm'"
          id="cellphone"
          [preferredCountries]="preferredCountries"
          [enableAutoCountrySelect]="true"
          [enablePlaceholder]="true"
          [searchCountryFlag]="true"
          [searchCountryField]="[
            SearchCountryField.Iso2,
            SearchCountryField.Name
          ]"
          [selectFirstCountry]="false"
          [maxLength]="10"
          [tooltipField]="TooltipLabel.Name"
          [phoneValidation]="true"
          [selectedCountryISO]="defaultCountry"
          [separateDialCode]="separateDialCode"
          (countryChange)="ChangeCountry($event)"
          name="cellphone"
          #MobileNumber
          formControlName="cellphone"
          
        >
        </ngx-intl-tel-input>
        <div class="form-control-feedback text-danger text-small"
                                *ngIf="driverForm.controls.cellphone.invalid && driverForm.controls.cellphone.dirty">
                                <p>Invalid Cellphone Number</p>
        </div>
        

      </div> -->
      <div class="col-12 col-md-6 form_field" *ngIf="driverForm.controls.id_type_ind.value == 2">
        <label class="label" for="traffic_register_number"
          >Traffic register number <a
          class="red-asterik">*</a></label
        >
        <input
          type="text"
          id="traffic_register_number"
          formControlName="traffic_register_number"
          class="form-control"
          (keypress)="numbersOnly($event)"
          placeholder="Traffic register number"
          maxlength="20"
        />
        <div *ngIf="driverForm.controls.traffic_register_number.invalid && driverForm.controls.traffic_register_number.touched">
          <p *ngIf="driverForm.controls.traffic_register_number.errors.required" class="form-control-feedback text-danger text-small text-red pt-3">
            * Required
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="license_type">License Type <a
          class="red-asterik">*</a></label>
        <select
          name="license_type"
          id="license_type"
          formControlName="license_type"
          class="form-control"
        >
          <option selected hidden disabled>Select License Type <a
            class="red-asterik">*</a></option>
          <ng-container *ngFor="let type of licenseTypes">
            <option [value]="type.key">{{ type.value }}</option>
          </ng-container>
        </select>
        <div *ngIf="driverForm.controls.license_type.invalid && driverForm.controls.license_type.touched">
          <p *ngIf="driverForm.controls.license_type.errors.required" class="form-control-feedback text-danger text-small text-red pt-3">
            * Required
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="license_number">License Number <a
          class="red-asterik">*</a></label>
        <input
          type="text"
          maxlength="20"
          id="license_number"
          (keypress)="numbersOnly($event)"
          formControlName="license_number"
          class="form-control"
          placeholder="License Number"
        />
        <div *ngIf="driverForm.controls.license_number.invalid && driverForm.controls.license_number.touched">
          <p *ngIf="driverForm.controls.license_number.errors.required" class="form-control-feedback text-danger text-small text-red pt-3">
            * Required
          </p>
        </div>
      </div>
      <!-- <div class="col-12 col-md-6 form_field">
        <label class="label" for="trn_date">Trn Issue Date <a
          class="red-asterik">*</a></label>
        <input
          type="date"
          id="trn_date"
          formControlName="trn_issue_date"
          class="form-control"
          placeholder="Trn Issue Date"
          [value]="driverForm.controls.trn_issue_date.value | date:'yyyy-MM-dd'"
        />
        <div *ngIf="driverForm.controls.trn_issue_date.invalid && driverForm.controls.trn_issue_date.touched">
          <p *ngIf="driverForm.controls.trn_issue_date.errors.required" class="form-control-feedback text-danger text-small text-red pt-3">
            * Required
          </p>
        </div>
      </div> -->
      <div class="col-12 col-md-6 form_field" [style]="driverForm.controls.id_type_ind.value == 2?'display: block;':'display:none'">
        <label class="label" for="dob">Trn Issue Date <a class="red-asterik">*</a></label>
        <div class="input-group">
          <input
            value="{{ trn_issue_date | date:'dd/MM/yyyy' }}"
            type="text"
            id="trn_issue_date"
            [placement]="'top'"
            container="body"
            readonly
            ngbDatepicker #trnDatePicker="ngbDatepicker" (click)="trnDatePicker.toggle()"
            formControlName="trn_issue_date"
            name="trn_issue_date"
            class="form-control"
            placeholder="Trn Issue Date"
           [maxDate]="getMaxDate()"
            [ngClass]="{'error': driverForm.controls.trn_issue_date.invalid && driverForm.controls.trn_issue_date.dirty, 'noerror': driverForm.controls.trn_issue_date.valid && driverForm.controls.trn_issue_date.dirty}" />

          <!-- <div class="input-group-append">
            <span class="input-group-text">
              <i class="fa fa-calendar" (click)="trn_issue_date.toggle()"></i>
            </span>
          </div> -->
        </div>
        <div *ngIf="driverForm.controls.trn_issue_date.invalid && driverForm.controls.trn_issue_date.touched">
          <p *ngIf="driverForm.controls.trn_issue_date.errors?.required" class="form-control-feedback text-danger text-small text-red pt-3">
            * Required
          </p>
        </div>
      </div>
      

      <div class="col-12 col-md-6 form_field" *ngIf="driverForm.controls.id_type_ind.value == 2">
        <label class="label" for="permit_number">Work permit number <a
          class="red-asterik">*</a></label>
        <input
          type="text"
          id="permit_number"
          (keypress)="numbersOnly($event)"
          formControlName="work_permit_number"
          class="form-control"
          placeholder="Work permit number"
        />
        <div *ngIf="driverForm.controls.work_permit_number.invalid && driverForm.controls.work_permit_number.touched">
          <p *ngIf="driverForm.controls.work_permit_number.errors.required" class="form-control-feedback text-danger text-small text-red pt-3">
            * Required
          </p>
        </div>
      </div>
      
      <div class="col-12 col-md-6 form_field"  [style]="driverForm.controls.id_type_ind.value == 2?'display: block;':'display:none'">
        <label class="label" for="work_permit_expiry_date"
          >Work permit expiry date <a
          class="red-asterik">*</a></label
        >
        <div class="input-group">
          <input
         
          value="{{work_permit_expiry_date | date:'dd/MM/yyyy' }}"
          type="text"
          [placement]="'top'"
          container="body"
          readonly
          ngbDatepicker #workDatePicker="ngbDatepicker" (click)="workDatePicker.toggle()"
          [minDate]="minValidityDate"
          id="work_permit_expiry_date"
          formControlName="work_permit_expiry_date"
          class="form-control"
          placeholder="Work permit expiry date"
          [ngClass]="{'error': driverForm.controls.work_permit_expiry_date.invalid && driverForm.controls.work_permit_expiry_date.dirty, 'noerror': driverForm.controls.work_permit_expiry_date.valid && driverForm.controls.work_permit_expiry_date.dirty}" />
          <!-- <div class="input-group-append">
          <span class="input-group-text">
            <i class="fa fa-calendar" (click)="work_permit_expiry_date.toggle()"></i>
          </span>
        </div> -->
      </div>
        <div *ngIf="driverForm.controls.work_permit_expiry_date.invalid && driverForm.controls.work_permit_expiry_date.touched">
          <p *ngIf="driverForm.controls.work_permit_expiry_date.errors.required" class="form-control-feedback text-danger text-small text-red pt-3">
            * Required
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="notes">Notes</label>
        <textarea
          name="notes"
          id="notes"
          formControlName="notes"
          class="form-control textarea"
          rows="8"
        ></textarea>
      </div>
    </div>

    <div class="card border-light shadow-sm" style="background-color: #f5f8ff !important">
      <div class="contact-details opensans-semi-bold-sapphire-30px">
        <span class="opensans-semi-bold-sapphire-30px">Driver Document Uploads</span>
      </div>
      <div class="rectangle-34"></div>
      <span class="opensans-semi-bold-black-16px-2">Please ensure documents being submitted are clear and
        visible, any document that is not clear and visible will be
        rejected.</span>
      <span class="opensans-semi-bold-black-16px-2">All foreign documents must be translated by a certified
        translator into English.</span>

      <div class="row m-0">
        <table style="width: 100%">
          <ng-container *ngFor="let UserDocument of uploadedDocs; let i = index">
            <tr>
              <td>
                <div class="contact-details opensans-bold-sapphire-20px">
                  <span class="opensans-bold-sapphire-20px">{{
                    UserDocument.description 
                    }} <span style="color: red;">*</span></span>
                </div>
                <div class="rectangle-34"></div>
                <br />
                <div>
                  <!-- {{filename}} -->
                </div>
                <label class="dropzone" fileDragDrop (filesChangeEmiter)="onFileChange($event, UserDocument.id)">
                  <div class="text-wrapper">
                    <div class="centered">
                      <img src="/assets/upload_icon.png" style="width: 21.33px" />
                      <input id="fileuploads{{ UserDocument.id }}" #fileuploads{{UserDocument.id}} type="file"
                        style="width: 100px" (change)="
                                  onFileSelected($event, UserDocument.id)
                                  " />
                      <br />
                      <label for="fileuploads{{ UserDocument.id }}"><span class="textLink">Drag and drop files here or
                          click to search
                          on your computer</span>
                        <br /><br />
                        <span style="
                                      text-decoration: underline;
                                      color: #274c9c;
                                    ">Upload file</span></label>
                    </div>
                  </div>
                </label>
              </td>
              <td></td>
              <td style="padding-right: 20px"></td>

              <td></td>
            </tr>
            <label><span class="txt-max">
                Max file size {{ maxMB }} PDF format.</span></label>
            <tr *ngFor="let Document of viewDocuments">
              <td *ngIf="UserDocument.id == Document.document_type_id">
                <div class="card">
                  <h5 class="card-title">Files Uploaded</h5>

                  <div class="card-body">
                    <!-- <h2>Files Uploaded(0)</h2> -->

                    <div class="row">
                      <div class="col-sm bg-light">
                        {{ Document.file_name }}
                      </div>
                      <div class="col-sm bg-light">PDF</div>
                      <div class="col-sm bg-light">
                        <span style="float: right !important">
                          <div class="file-upload-icons-group">
                            <a><img title="View Document" class="file-upload-icon" src="/assets/visibility.png"
                                alt="visibility" data-toggle="modal" data-target="#driverViewDoc" (click)="
                                viewDoc(
                                  Document.document_type_id,
                                  Document.document_link
                                            )
                                          " /></a>
                            <img title="Delete Document" class="file-upload-icon" (click)="onConfirm(Document)"
                              src="/assets/delete.png" alt="delete" />
                          </div>
                          <!-- <span title="Upload another of the same type" *ngIf="UserDocument.multiple_allowed == true" class="btn btn-primary btn-sm"><i
                              class="fa fa-plus" aria-hidden="true" (click)="extraDoc(UserDocument)"></i></span> -->
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <td></td>
            </tr>
          </ng-container>

          <tr *ngIf="uploadedDocs?.length == 0">
            <td>No Documents found</td>
          </tr>
        </table>
      </div>
    </div>




    <div class="action_btns">
      <div class="btn_wrap">
        <button type="button" (click)="onClickBack()" class="btn btn_secondary">
          Back
        </button>
      </div>
      <div class="btn_wrap">
        <button type="submit" (click)="submitForm()" class="btn btn_primary">
          Save
        </button>
      </div>
    </div>
  </form>
</div>


<div
  class="modal fade"
  id="driverViewDoc"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLongTitle"
  aria-hidden="true"
>


  <div class="modal-dialog modal-lg" tabindex="-1" aria-hidden="true" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Driver Document View</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body modal-lg">
              <div style="width: 99%; min-height: 470px">
                <pdf-viewer
                  *ngIf="pdfSrc"
                  [src]="pdfSrc"
                  [render-text]="true"
                  style="display: block"
                  [original-size]="false"
                  [autoresize]="true"
                ></pdf-viewer>
                <img [src]="img" *ngIf="img" />
                <ngx-loading [show]="isLoading"></ngx-loading>
              </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn pull-right btn_secondary" data-dismiss="modal">Close</button>
                 <!-- <button type="button" class="btn btn-primary">Save changes</button>  -->
</div>
</div>
</div>
</div>
